import React, { useContext, useState, useEffect } from 'react';
import { Select, Button } from '@mui/material';
import { InputLabel } from '@mui/material';
import { MenuItem, Typography } from '@mui/material';
import { FormControl } from '@mui/material';
import RouteContext from '../contexts/RouteContext';
import StopsContext from '../contexts/StopsContext';
import FieldActivity from '../classes/FieldActivity';
import ContainerRoute from '../classes/ContainerRoute';
import AllRouteDataContext from '../contexts/AllRouteDataContext';


export function RouteSelector(props) {

    const { allRoutes } = useContext(AllRouteDataContext);
    const { containerRoute, setContainerRoute } = useContext(RouteContext);
    const { setStops } = useContext(StopsContext);
    const [routeNumbers, setRouteNumbers] = useState([]);
    const [selectedRouteNumber, setSelectedRouteNumber] = useState('');

    useEffect(() => {

        //let routeNumberArray = [];
        //build the route number array from the length of allRoutes array
        //routeNumberArray = Array.from(Array(allRoutes.length), (x, index) => index + 1);
        var routeNumArray = [];
        for (var route of allRoutes){
            routeNumArray.push(route.routeNumber);
        }

        setRouteNumbers(routeNumArray);
    },[]);


    const handleChange = (event) => {
        const routeStops = [];

        setSelectedRouteNumber(event.target.value);
        let selectedRoute = allRoutes.find(({routeNumber}) => routeNumber === String(event.target.value));
        let matchContainerRoute = new ContainerRoute(selectedRoute.id, selectedRoute.routeDate, selectedRoute.routeNumber);
        setContainerRoute(matchContainerRoute);

        for(let i in selectedRoute.stops) {
            let fieldActivity = new FieldActivity(selectedRoute.stops[i]);
            routeStops.push(fieldActivity);
        }
        setStops(routeStops);

    };

    const handleRenderValue = () => {
        return containerRoute.RouteNumber;
    };

    if (!routeNumbers){
        return (
            <div>
                <Typography>Whoops...something went wrong.</Typography>
                <p>
                    <Button variant="contained" color="primary" onClick={() => window.location.reload(false)}>
                        Click here to retry
                    </Button>
                </p>
            </div>

        );
    }

    if (routeNumbers.length === 0) {
        return (
            <React.Fragment>
                <div className="route-selector">
                    <FormControl id="routeSelectForm" variant="standard" sx={{ margin: "8px", minWidth: "220px" }}>
                        <InputLabel id="routeSelectLabel">Route</InputLabel>
                        <Select
                            labelId="routeSelectLabel"
                            id="routeSelect"
                            value={selectedRouteNumber}
                            defaultValue=""
                            onChange={handleChange}
                        >
                            {routeNumbers.map(
                                routeNumber => <MenuItem key={routeNumber} value={routeNumber}>{routeNumber}</MenuItem>
                                )
                            }
                        </Select>
                    </FormControl>
                </div>
                <br />
                <Typography>Looks like there are no routes available to choose today...</Typography>
            </React.Fragment>
        );
    } else {
        return (
            <div className="route-selector">
                <FormControl id="routeSelectForm" variant="standard" sx={{ margin: "8px", minWidth: "220px" }}>
                    <InputLabel shrink id="routeSelectLabel">Route</InputLabel>
                    <Select
                        labelId="routeSelectLabel"
                        id="routeSelect"
                        value={selectedRouteNumber}
                        defaultValue=""
                        renderValue={handleRenderValue}
                        displayEmpty={true}
                        onChange={handleChange}
                    >
                        {routeNumbers.map(
                            routeNumber => <MenuItem key={routeNumber} value={routeNumber}>{routeNumber}</MenuItem>
                            )
                        }
                    </Select>
                </FormControl>
            </div>
        );
    }


}

